import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { CaptchaService } from '../../services/captcha-service/captcha.service';

@Component({
  selector: 'app-recaptcha-widget',
  standalone: false,
  template: `<div *ngIf="captchaService.isEnabled()" #captchaContainer class="recaptcha-container"></div>`
})
export class RecaptchaWidgetComponent implements AfterViewInit {
  @ViewChild('captchaContainer') captchaContainer!: ElementRef<HTMLDivElement>;
  @Output() resolved = new EventEmitter<void>();
  @Output() expired = new EventEmitter<void>();

  widgetId = -1;

  constructor(public captchaService: CaptchaService) {}

  ngAfterViewInit(): void {
    if (!this.captchaService.isEnabled()) {
      return;
    }

    this.captchaService
      .render(
        this.captchaContainer.nativeElement,
        () => this.resolved.emit(),
        () => this.expired.emit()
      )
      .then((widgetId) => {
        this.widgetId = widgetId;
      });
  }

  getToken(): string {
    return this.captchaService.getResponse(this.widgetId);
  }

  reset(): void {
    this.captchaService.reset(this.widgetId);
    this.expired.emit();
  }

  hasValidToken(): boolean {
    return !this.captchaService.isEnabled() || !!this.getToken();
  }
}
